window.onload = async () => {
  if (document.querySelectorAll('.header').length) {
    import('./navbar').then((module) => module.default());
    import('./menu').then((module) => module.default());
  }
  if (document.querySelectorAll('.slider').length) {
    import('./slider').then((module) => module.default());
  }
  if (document.querySelectorAll('.notice-wrapper').length) {
    import('./notice').then((module) => module.default());
  }
  if (document.querySelectorAll('.popup').length) {
    import('./popup').then((module) => module.default());
  }
  if (document.querySelectorAll('.guidelines').length) {
    import('./guidelines').then((module) => module.default());
  }
  if (document.querySelectorAll('.anchor-content').length) {
    import('./sidebar-anchors').then((module) => module.default());
  }
  console.log('main.ts loaded');
  if (document.querySelectorAll('.materials_overview__category').length) {
    console.log('materialsFilter.ts loaded');
    import('./materialsFilter').then((module) => module.default());
  }
};
